// @flow
import * as React from "react";
import { Divider, Responsive } from "semantic-ui-react";

import ReminderContent from "./Content";
import ReminderHeader from "./Header";
import { RemoveReminder } from "../../../components";
import { ExpandableSegment, Loading } from "../../../../../Commons/Components";
import i18n from "../../../../../i18n";

import Styles from "./Reminder.module.scss";

import type { ReminderT } from "../../../misc/Types";

type Props = {
  reminder: ReminderT,
  initiallyOpened?: boolean,
  openCallBack?: Function,
};

export function Reminder({ reminder, initiallyOpened = false, openCallBack }: Props) {
  return (
    <ExpandableSegment
      expanded={initiallyOpened}
      openCallBack={openCallBack}
      header={<Reminder.Header reminder={reminder} />}
    >
      <Responsive maxWidth={Responsive.onlyMobile.maxWidth}>
        <div className={Styles["reminder__sub-header"]}>
          <Responsive maxWidth={Responsive.onlyMobile.maxWidth}>
            <div style={{ flexGrow: 1 }}>
              <Reminder.Header.State.Message reminder={reminder} />
            </div>
            <Reminder.Header.Divider />
            <Reminder.Header.Company reminder={reminder} />
          </Responsive>
        </div>
      </Responsive>
      <Responsive maxWidth={Responsive.onlyMobile.maxWidth}>
        <Divider />
      </Responsive>
      <Reminder.Content reminder={reminder} />
      <RemoveReminder>
        {({ isRemoving, remove }: Dict) => {
          if (isRemoving) {
            return (
              <div className={Styles["loading"]}>
                <Loading inline size="mini" />
                <span style={{ color: "grey", marginLeft: ".75em" }}>{i18n.t("reminder:reminder.remove")}</span>
              </div>
            );
          }

          return (
            <div className={Styles["remove"]}>
              <span
                onClick={() => {
                  remove(reminder.id);
                }}
                style={{ color: "#dd0000", cursor: "pointer" }}
              >
                {i18n.t("reminder:reminder.remove")}
              </span>
            </div>
          );
        }}
      </RemoveReminder>
    </ExpandableSegment>
  );
}

Reminder.Content = ReminderContent;
Reminder.Header = ReminderHeader;

export default Reminder;
